import { ActivityCosts, ActivityCostsAdjustments, ActivityCostsTotals } from '@faro/study-designer-model';
import axios from 'axios';
import { RevisionQueryParameter, ScheduleOfActivitiesQueryParameter, StudyPathParameter } from '../parameter';

export type ActivityCostsParameters = StudyPathParameter & ScheduleOfActivitiesQueryParameter & RevisionQueryParameter;

export const activityCostsClient = {
    get(params: ActivityCostsParameters): Promise<ActivityCosts[]> {
        const { studyId, scheduleOfActivitiesId, revision } = params;
        return axios
            .get(`/api/study-designer/studies/${studyId}/activity-costs`, {
                params: { scheduleOfActivitiesId, revision },
            })
            .then(response => response.data);
    },
    getTotals(params: ActivityCostsParameters): Promise<ActivityCostsTotals> {
        const { studyId, scheduleOfActivitiesId, revision } = params;
        return axios
            .get(`/api/study-designer/studies/${studyId}/activity-costs/totals`, {
                params: { scheduleOfActivitiesId, revision },
            })
            .then(response => response.data);
    },
    getTotalsWithAdjustments(
        params: StudyPathParameter & { adjustments: ActivityCostsAdjustments }
    ): Promise<ActivityCostsTotals> {
        const { studyId, adjustments } = params;
        return axios
            .post(`/api/study-designer/studies/${studyId}/activity-costs/adjust/totals`, adjustments)
            .then(response => response.data);
    },
};
